// extracted by mini-css-extract-plugin
export default {"root":"IconHamburgerMenu_root__34DN3"};